export default class ShellyScriptEditorHistory {
	private _textEditor: HTMLTextAreaElement;
	private _index = 0;
	private _stack: {
		position: number;
		remove: string;
		append: string;
		inputType: string;
	}[] = [];
	constructor(textEditor: HTMLTextAreaElement) {
		this._textEditor = textEditor;
		this._textEditor.addEventListener('beforeinput', this._onBeforeInput);
	}
	public undo() {
		if (this._index - 1 < 0) return null;
		const item = this._stack[--this._index];
		let position = item.position + item.remove.length;
		const value =
			this._textEditor.value.slice(0, item.position) +
			item.remove +
			this._textEditor.value.slice(item.position + item.append.length);
		if (item.remove.length == 1) {
			if (item.inputType == 'deleteContentForward') position -= 1;
			this._update(value, position, item.remove);
		} else this._update(value, item.position, item.remove, position);
	}
	public redo() {
		if (this._index == this._stack.length) return null;
		const item = this._stack[this._index++],
			value =
				this._textEditor.value.slice(0, item.position) +
				item.append +
				this._textEditor.value.slice(item.position + item.remove.length);
		this._update(value, item.position + item.append.length, item.append);
	}
	public destroy() {
		this._textEditor.removeEventListener('beforeinput', this._onBeforeInput);
		this.reset();
	}
	public reset() {
		this._stack = [];
		this._index = 0;
	}
	private _onBeforeInput = (e: InputEvent | CustomEvent) => {
		if (e instanceof InputEvent && /^(history|format)/.test(e.inputType)) return;
		let position =
				e instanceof CustomEvent && e.detail.selectionStart
					? e.detail.selectionStart
					: this._textEditor.selectionStart,
			end = this._textEditor.selectionEnd,
			append = (e instanceof InputEvent ? e.data : e.detail.text) || '';
		if (e instanceof InputEvent) {
			if (e.inputType == 'deleteContentBackward' && position == end) position -= 1;
			else if (e.inputType == 'deleteContentForward' && position == end) end += 1;
			else if (e.inputType == 'insertFromPaste') append = append.replace(/\r(\n)?/g, '\n');
		}
		const remove = this._textEditor.value.slice(position, end),
			item = {
				position,
				remove,
				append,
				inputType: e instanceof InputEvent ? e.inputType : e.detail.inputType,
			};
		if (remove == append) return;
		this._stack = this._stack.slice(0, this._index);
		this._stack.push(item);
		this._index = this._stack.length;
	};
	private _update(value: string, position: number, append: string, endPosition: number = null) {
		this._textEditor.value = value;
		this._textEditor.dispatchEvent(new Event('input', { cancelable: true }));
		if (/(^{.*}$)|(^\(.*\)$)|(^\[.*\]$)/.test(append)) position -= 1;
		this._textEditor.selectionStart = position;
		this._textEditor.selectionEnd = endPosition ? endPosition : position;
		this._textEditor.focus();
	}
}
